import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Scale, Clock } from 'lucide-react';
const advantages = [{
  icon: <Scale size={28} strokeWidth={1.5} data-id="element-31" />,
  title: 'Комплексний підхід',
  description: 'Ми дивимося на проблему ширше. Наприклад, вирішуючи питання спадщини, відразу прораховуємо податкові ризики та захищаємо майно від претензій кредиторів.'
}, {
  icon: <ShieldCheck size={28} strokeWidth={1.5} data-id="element-32" />,
  title: 'Досвід у судах та держорганах',
  description: 'Не обмежуємося відправкою адвокатських запитів. Впевнено ведемо справи в судах усіх інстанцій та захищаємо клієнта перед ТЦК, банками або виконавцями.'
}, {
  icon: <Clock size={28} strokeWidth={1.5} data-id="element-33" />,
  title: 'Швидке реагування',
  description: 'У питаннях мобілізації або арешту майна рахунок йде на години. Ми миттєво включаємося в процес і оперативно готуємо документи.'
}];
export function Advantages() {
  return <section className="py-24 bg-background" data-id="element-34">
      <div className="max-w-7xl mx-auto px-6" data-id="element-35">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-37">
            Чому обирають нас
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-38">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface p-8 rounded-3xl border border-border hover:border-primary/50 transition-colors duration-300" data-id="element-39">
              <div className="w-14 h-14 bg-background rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-40">
                {adv.icon}
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-41">{adv.title}</h3>
              <p className="text-secondary leading-relaxed text-sm" data-id="element-42">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}